import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from "@ngrx/store";
import IUser from "@skills-app/models/user";
import {
  UserSearchBarActions,
  UserSearchBarApiActions,
} from "@skills-app/shared/actions";

export interface IUserSearchBarState {
  filteredUsers: IUser[];
  selectedUsers: IUser[];
}

const initialState: IUserSearchBarState = {
  filteredUsers: [],
  selectedUsers: [],
};

export const reducer = createReducer(
  initialState,
  on(UserSearchBarApiActions.requestFilterUserSuccess, (state, action) => ({
    ...state,
    filteredUsers: action.users,
  })),
  on(UserSearchBarActions.setUsersToSearch, (state, action) => ({
    ...state,
    selectedUsers: action.users.length
      ? [...state.selectedUsers, ...action.users]
      : state.selectedUsers,
  })),
  on(UserSearchBarActions.addUserToSearch, (state, action) => ({
    ...state,
    selectedUsers: state.selectedUsers.find(
      (x) => x.AzureId === action.user.AzureId,
    )
      ? state.selectedUsers
      : [...state.selectedUsers, action.user],
  })),
  on(UserSearchBarActions.removeUserFromSearch, (state, action) => ({
    ...state,
    selectedUsers: state.selectedUsers.filter(
      (x) => x.AzureId !== action.user.AzureId,
    ),
  })),
  on(UserSearchBarActions.clearSelectedUsers, (state) => ({
    ...state,
    selectedUsers: [],
  })),
);

export const getUserSearchBarState =
  createFeatureSelector<IUserSearchBarState>("filteredUsers");

export const getFilteredUsers = createSelector(
  getUserSearchBarState,
  (usersState) => usersState.filteredUsers,
);

export const getSelectedUsers = createSelector(
  getUserSearchBarState,
  (usersState) => usersState.selectedUsers,
);
